import type { IconProps } from './types/types';

const SparkleIcon = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path d="M11.5134 6.06228C11.6345 5.54872 12.3655 5.54872 12.4866 6.06228L13.3144 9.57019C13.4449 10.1233 13.8767 10.5551 14.4298 10.6856L17.9377 11.5134C18.4513 11.6345 18.4513 12.3655 17.9377 12.4866L14.4298 13.3144C13.8767 13.4449 13.4449 13.8767 13.3144 14.4298L12.4866 17.9377C12.3655 18.4513 11.6345 18.4513 11.5134 17.9377L10.6856 14.4298C10.5551 13.8767 10.1233 13.4449 9.57019 13.3144L6.06228 12.4866C5.54872 12.3655 5.54872 11.6345 6.06228 11.5134L9.57019 10.6856C10.1233 10.5551 10.5551 10.1233 10.6856 9.57019L11.5134 6.06228Z" />
    </svg>
  );
};

export default SparkleIcon;
